import React, { useState } from "react";

import AdminAppBar from "../../adminComponents/AdminAppBar";
import CustomHeading from "../../common/CustomHeading";
import CustomButton from "../../common/CustomButton";
import { Sidebar } from "primereact/sidebar";

import { MdRemoveRedEye } from "react-icons/md";
import CustomTruncatedText from "../../common/CustomTruncatedText";
import CustomTable from "../../common/CustomTable";
import CustomAPIForm from "./CustomAPIForm";

const CustomAPIMainContent = () => {
  const [visibleForm, setVisibleForm] = useState(false);
  const data = [
    {
      name: "john doewfsefefsefsfsfsfsfsfsfsfsfsfjsdljfslfjjlsdflsflsdjfslfsljbfslfbsljf",
      phoneNumber: "9876543210",
      countryCode: "91",
      status: "New",
      Quality: "Hot",
      location: [{ name: "Delhi" }, { name: "Mumbai" }],
      teamName: "Sales Team",
      userName: "Ravi Kumar",
    },
    {
      name: "jane smith",
      phoneNumber: "1234567890",
      countryCode: "1",
      status: "Contacted",
      Quality: "Cold",
      location: [{ name: "New York" }],
      teamName: "Marketing",
      userName: "Sarah",
    },
  ];

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => {
        const capitalized = text?.replace(/\b\w/g, (char) =>
          char.toUpperCase()
        );
        return (
          <div
            className="text-blue-500 truncate cursor-pointer"
            title={capitalized}
          >
            <CustomTruncatedText text={capitalized} maxLength={20} />
          </div>
        );
      },
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="truncate">
          +{record.countryCode} {text}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (value) => (
        <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs">
          {value || "Unknown"}
        </span>
      ),
    },
    {
      key: "Quality",
      title: "Lead Quality",
      render: (value) => (
        <span className="text-sm font-medium">{value || "No Quality"}</span>
      ),
    },
    {
      key: "location",
      title: "Location",
      render: (value) => {
        const firstLocation = value?.[0]?.name || "No Location";
        const extra = value?.length > 1 ? ` +${value.length - 1}` : "";
        const fullTitle = value?.map((loc) => loc.name).join(", ");

        return (
          <span className="truncate block max-w-[150px]" title={fullTitle}>
            {firstLocation}
            <span className="text-blue-500">{extra}</span>
          </span>
        );
      },
    },
    {
      key: "teamName",
      title: "Team",
      render: (value) => (
        <div className="truncate" title={value}>
          {value}
        </div>
      ),
    },
    {
      key: "Action",
      title: "Action",
      render: (value, record) => (
        <div className="flex justify-center gap-2">
          <MdRemoveRedEye className="text-2xl text-customGreen" />
        </div>
      ),
    },
  ];

  const handleFormData = () => {
    setVisibleForm(true);
  };

  return (
    <div>
      <AdminAppBar />

      <div className="pt-28 px-6">
        <div className="flex items-center justify-between">
          <CustomHeading title={"API Management"} isIcon={true} />
          <CustomButton label={"Create API"} onClick={handleFormData} />
        </div>

        <div className=" w-full mt-[50px]">
          <CustomTable columns={columns} data={data} />
        </div>

        <Sidebar
          header={
            <div className="flex items-center justify-between w-full">
              <span className="font-semibold text-lg text-customGreen">
               {"Create API"}
              </span>
            </div>
          }
          visible={visibleForm}
          onHide={() => {
            setVisibleForm(false);
          }}
          style={{ width: "500px" }}
          position="right"
          className="p-sidebar-md"
        >
          <CustomAPIForm
            onClose={() => {
              setVisibleForm(false);
            }}
          />
        </Sidebar>
      </div>
    </div>
  );
};

export default CustomAPIMainContent;
